import { Link } from 'react-router-dom';
import { API_BASE_URL } from '@app/api/client';
import { ConversePage } from '@app/main/Conversar';
import { t } from '@app/i18n';
import s from './DemoConsole.module.css';

/**
 * **Console de demonstração** (`/console-de-demo`, 29/08) — a moldura da
 * ferramenta de bastidor.
 *
 * O pedido (mrolim) foi de moldura, não de comportamento: o conteúdo continua
 * sendo T25 inteira — os mesmos seletores, a mesma conversa, a mesma trilha do
 * salto, a mesma linha da decisão do PDP e o mesmo canal com queda para REST.
 * O que muda é o que está em volta.
 *
 * ## O que esta página deixa de fora, de propósito
 *
 * Rail, topbar, contadores, sino, busca global e o logo do produto. A rota mora
 * **fora** da rota-mãe do `Shell` (`routes.tsx`) justamente por isso: dentro dela
 * a moldura viria junto, e a tela continuaria parecendo uma tela do 360 Agentic
 * Identity. Ela é uma ferramenta que fala com o cluster do laboratório para
 * apoiar a demonstração — e o cabeçalho diz isso em uma linha, para quem estiver
 * vendo a apresentação não confundir as duas coisas.
 *
 * O guard de sessão e o de papel continuam onde estavam (`routes.tsx`): admin, e
 * quem não é vai para a Visão geral, como em qualquer URL que não existe — a
 * página não anuncia a própria existência.
 */

/**
 * O host com que a página está falando: o `VITE_API_URL` quando existe (o
 * `publicURL` do backend nas instalações do lab), a origem da própria página
 * quando o nginx proxia `/api` na mesma origem.
 *
 * Serve para quem apresenta não errar de ambiente — a chamada que sai daqui
 * executa **de verdade** no cluster para onde este host aponta.
 */
function hostDoAmbiente(): string {
  const base = API_BASE_URL.trim();
  if (!base) return window.location.host;
  try {
    return new URL(base, window.location.href).host;
  } catch {
    // Base configurada com algo que não é URL: mostrar o valor cru é mais
    // honesto que esconder o ambiente.
    return base;
  }
}

export function DemoConsolePage() {
  return (
    <div className={s.pagina} data-console-demo="">
      {/* O `banner` da página é este — a topbar do produto não vem junto, e é
          por isso que o teste da rota consegue afirmar qual dos dois está no
          ar pelo nome do landmark. */}
      <header className={s.cabecalho} aria-label={t('conversation.demoConsole.title')}>
        <div className={s.identidade}>
          <p className={s.etiqueta}>{t('conversation.demoConsole.kind')}</p>
          <h1 className={s.nome}>{t('conversation.demoConsole.title')}</h1>
          <p className={s.linha}>{t('conversation.demoConsole.description')}</p>
        </div>

        <div className={s.ambiente}>
          <p className={s.ambienteRotulo}>{t('conversation.demoConsole.environment')}</p>
          <p className={s.ambienteValor} data-testid="ambiente-da-demo">
            {hostDoAmbiente()}
          </p>
          <Link className={s.voltar} to="/">
            {t('conversation.demoConsole.back')}
          </Link>
        </div>
      </header>

      <main className={s.conteudo}>
        <ConversePage />
      </main>
    </div>
  );
}
